import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./BitacoraEnvasado.css";

import { obtenerNoTerminadoRecords, guardarNoTerminadoRecord } from "../../../redux/DucksBeneficiario/BitacoraEnvasadoNoTerminadoDucks";
import { obtenerTerminadoRecords, guardarTerminadoRecord } from "../../../redux/DucksBeneficiario/BitacoraEnvasadoTerminadoDucks";
import { obtenerHologramasRecords, guardarHologramasRecord } from "../../../redux/DucksBeneficiario/BitacoraEnvasadoHologramasDucks";
import { obtenerGranelRecords, guardarGranelRecord, fusionarGranelRecords } from "../../../redux/DucksBeneficiario/BitacoraEnvasadoGranelDucks";

// Material UI Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ScienceIcon from '@mui/icons-material/Science';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

// Subcomponents
import InventarioGranelSection from "./BitacoraEnvasado/InventarioGranelSection";
import EnvasadoNoTerminadoSection from "./BitacoraEnvasado/EnvasadoNoTerminadoSection";
import EnvasadoTerminadoSection from "./BitacoraEnvasado/EnvasadoTerminadoSection";
import ControlHologramasSection from "./BitacoraEnvasado/ControlHologramasSection";
import ElaboracionClasesSection from "./BitacoraEnvasado/ElaboracionClasesSection";
import InventarioMaduracionSection from "./BitacoraEnvasado/InventarioMaduracionSection";
import CondicionesMaduracionSection from "./BitacoraEnvasado/CondicionesMaduracionSection";
import QuejasSection from "./BitacoraEnvasado/QuejasSection";

const BitacoraEnvasado = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.Usuario?.data);
  const idLogin = currentUser?.user?.[0]?.id || currentUser?.idlogin || currentUser?.id_login || currentUser?.id || null;

  const { records: apiNoTerminadoRecords } = useSelector(state => state.bitacoraEnvasadoNoTerminado || { records: [] });
  const { records: apiTerminadoRecords } = useSelector(state => state.bitacoraEnvasadoTerminado || { records: [] });
  const { records: apiHologramaRecords } = useSelector(state => state.bitacoraEnvasadoHologramas || { records: [] });
  const { records: apiGranelRecords } = useSelector(state => state.bitacoraEnvasadoGranel || { records: [] });

  // Batch selector
  const [activeBatch, setActiveBatch] = useState("Lote 01-ENV-2026");
  const [showBatchDropdown, setShowBatchDropdown] = useState(false);
  const batches = ["Lote 01-ENV-2026", "Lote 02-ENV-2026", "Lote 03-ENV-2026"];

  // Tab navigation state
  const [activeTab, setActiveTab] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const tabsInfo = [
    { title: "Sección II", name: "Granel", desc: "Inventarios de Mezcal a Granel", icon: LocalBarIcon, theme: "status-cierre" },
    { title: "Sección III", name: "Envasado No Terminado", desc: "Inventario de botellas sin etiquetar", icon: ShoppingBagIcon, theme: "status-coccion" },
    { title: "Sección IV", name: "Envasado Terminado", desc: "Inventario de botellas con holograma", icon: WorkspacePremiumIcon, theme: "status-elaboracion" },
    { title: "Sección V", name: "Hologramas", desc: "Control del Inventario de Hologramas", icon: ConfirmationNumberIcon, theme: "status-maduracion" },
    { title: "Sección VI", name: "Elaboración de Clases", desc: "Abocado, destilado con o reprocesos", icon: ScienceIcon, theme: "status-elaboracion" },
    { title: "Sección VII", name: "Maduración", desc: "Inventarios en Maduración", icon: HourglassBottomIcon, theme: "status-maduracion" },
    { title: "Sección VIII", name: "Condiciones", desc: "Registro de Condiciones", icon: DeviceThermostatIcon, theme: "status-cierre" },
    { title: "Sección IX", name: "Quejas", desc: "Quejas del Producto Certificado", icon: ReportProblemIcon, theme: "status-coccion" }
  ];

  // ================= DATA HISTORY STATES =================
  const [granelRecords, setGranelRecords] = useState([
    {
      id: "GRA-ENV-01",
      fechaMovimiento: "2026-07-15",
      idContenedor: "C-10",
      noLote: "PROD-LOTE-01",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingrediente: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      invInicialVol: "1000",
      invInicialAlc: "48.5",
      entradaProcedencia: "Destilación Lote 01",
      entradaVolumen: "0",
      entradaAlc: "0.0",
      entradaVolAgua: "0",
      salidaVolumen: "300",
      salidaAlc: "48.5",
      salidaDestino: "Línea 1 - Envasado Botella 750ml",
      invFinalVol: "700",
      invFinalAlc: "48.5",
      observaciones: "Salida para primer turno de envasado.",
      inspector: "Ing. Carlos Mendoza (15/07/2026)",
      status: "aprobado"
    }
  ]);

  const [noTerminadoRecords, setNoTerminadoRecords] = useState([
    {
      id: "NT-ENV-01",
      fechaMovimiento: "2026-07-16",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-NT",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingrediente: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlc: "48.5",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Línea de Envasado 1",
      entradaCajas: "50",
      entradaBotellas: "600",
      salidaCajas: "10",
      salidaBotellas: "120",
      salidaDestino: "Área de Etiquetado y Hologramas",
      invFinalCajas: "40",
      invFinalBotellas: "480",
      mermas: "2 botellas (rotura en línea)",
      observaciones: "Envasado inicial de lote sin etiquetar.",
      inspector: "Ing. Carlos Mendoza (16/07/2026)",
      status: "aprobado"
    }
  ]);

  const [terminadoRecords, setTerminadoRecords] = useState([
    {
      id: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      botCaja: "12 botellas",
      marca: "Don Julio Mezcal",
      noLoteGranel: "PROD-LOTE-01",
      loteEnvasado: "L-01-ENV-T",
      categoria: "Mezcal Artesanal",
      claseEtiqueta: "Joven / Blanco",
      ingredientesEtiqueta: "Maguey Espadín",
      edad: "Sin edad",
      tipoMagueyEtiqueta: "Espadín",
      noAnalisis: "ANA-2026-098",
      capacidad: "750 ml",
      pctAlcEtiqueta: "48.5",
      noInformeAprobacion: "INF-APR-ET-102",
      fechaAprobacionEtiqueta: "2026-07-17",
      invInicialCajas: "0",
      invInicialBotellas: "0",
      entradaProcedencia: "Etiquetado Lote NT-01",
      entradaCajas: "10",
      entradaBotellas: "120",
      salidaCajas: "5",
      salidaBotellas: "60",
      salidaDestino: "Almacén de Producto Terminado",
      invFinalCajas: "5",
      invFinalBotellas: "60",
      observaciones: "Ingreso inicial de botellas con holograma oficial.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const [hologramaRecords, setHologramaRecords] = useState([
    {
      id: "HOL-01",
      idEnvasadoTerminado: "T-ENV-01",
      fechaMovimiento: "2026-07-18",
      marca: "Don Julio Mezcal",
      loteEnvasado: "L-01-ENV-T",
      capacidad: "750 ml",
      invInicialRango: "A0001 - A0500",
      invInicialCant: "500",
      entradaRango: "N/A",
      entradaCant: "0",
      salidaRango: "A0001 - A0120",
      salidaCant: "120",
      invFinalRango: "A0123 - A0500",
      invFinalCant: "378",
      mermasRango: "A0121 - A0122",
      mermasCant: "2",
      observaciones: "Aplicación inicial de hologramas para primer lote terminado.",
      inspector: "Ing. Carlos Mendoza (18/07/2026)",
      status: "aprobado"
    }
  ]);

  const [elaboracionRecords, setElaboracionRecords] = useState([
    {
      id: "ELAB-01",
      fechaIngreso: "2026-07-16",
      loteOrigen: "PROD-LOTE-01",
      volumenOrigen: "700",
      pctAlcOrigen: "48.5",
      categoriaOrigen: "Mezcal Artesanal",
      claseOrigen: "Joven / Blanco",
      ingredientesOrigen: "Maguey Espadín",
      edadOrigen: "Sin edad",
      analisisOrigen: "ANA-2026-098",
      tipoMagueyOrigen: "Espadín",
      ingredientesAdicionados: "Gusano de maguey",
      procesoRealizado: "ABOCADO CON",
      descripcionProceso: "Adición de gusano de maguey deshidratado a lote granel antes del envasado.",
      fechaSalida: "2026-07-17",
      loteSalida: "L-01-ENV-AB",
      volumenSalida: "695",
      pctAlcSalida: "48.2",
      claseSalida: "Abocado con Gusano",
      observaciones: "Filtración leve and adición manual de gusano.",
      inspector: "Ing. Carlos Mendoza (17/07/2026)",
      status: "aprobado"
    }
  ]);

  const [maduracionRecords, setMaduracionRecords] = useState([
    {
      id: "MAD-01",
      fechaMovimiento: "2026-07-15",
      noLote: "PROD-LOTE-01",
      categoria: "Mezcal Artesanal",
      clase: "Joven / Blanco",
      ingredientes: "Maguey Espadín",
      edad: "Sin edad",
      tipoMaguey: "Espadín",
      noAnalisis: "ANA-2026-098",
      tipoRecipiente: "BARRICAS DE MADERA DE",
      detalleRecipiente: "Roble Blanco Americano",
      invInicialFecha: "2026-07-15",
      invInicialRecipientes: "2",
      invInicialVolumen: "400",
      invInicialAlc: "48.5",
      entradaFolio: "FOL-ING-502",
      entradaRecipientes: "0",
      entradaVolumen: "0",
      entradaAlc: "0.0",
      salidaRecipientes: "1",
      salidaVolumen: "200",
      salidaAlc: "48.0",
      salidaClaseObtenida: "Reposado",
      salidaEdadObtenida: "3 meses",
      salidaMerma: "5",
      invFinalRecipientes: "1",
      invFinalVolumen: "195",
      invFinalAlc: "48.0",
      observaciones: "Inicio de reposado en barrica de roble.",
      inspector: "Ing. Carlos Mendoza (15/07/2026)",
      status: "aprobado"
    }
  ]);

  // Default pre-filled month for conditions
  const generateDefaultDailyData = () => {
    return Array.from({ length: 31 }).map((_, i) => ({
      dia: i + 1,
      hora: i < 5 ? "09:00" : "",
      temp: i < 5 ? (23 + (i % 3)).toString() : "",
      hum: i < 5 ? (60 - (i % 4)).toString() : ""
    }));
  };

  const [condionesRecords, setCondicionesRecords] = useState([
    {
      mesAnio: "Julio 2026",
      noLote: "PROD-LOTE-01",
      registros: generateDefaultDailyData(),
      observaciones: "Monitoreo correspondiente a los primeros días de maduración en bodega.",
      inspector: "Ing. Carlos Mendoza (19/07/2026)",
      status: "aprobado"
    }
  ]);

  const [quejasRecords, setQuejasRecords] = useState([
    {
      id: 1,
      fechaQueja: "2026-07-10",
      noQueja: "QJ-2026-001",
      noLote: "L-01-ENV-T",
      descripcionProducto: "Don Julio Mezcal - Mezcal Artesanal Joven / Blanco (750 ml)",
      detalleQueja: "El cliente reportó fuga leve de líquido en el tapón de corcho de 2 botellas.",
      fechaAtencion: "2026-07-12",
      medidasCorrectivas: "Se cambiaron los corchos del lote restante por un lote de mayor densidad y se re-inspeccionó el empaque.",
      inspector: "Ing. Carlos Mendoza (12/07/2026)",
      status: "aprobado"
    }
  ]);

  // Sync API records into local state when API fetches complete
  useEffect(() => {
    if (idLogin) {
      dispatch(obtenerNoTerminadoRecords({ idLogin }));
      dispatch(obtenerTerminadoRecords({ idLogin }));
      dispatch(obtenerHologramasRecords({ idLogin }));
      dispatch(obtenerGranelRecords({ idLogin }));
    }
  }, [dispatch, idLogin]);

  useEffect(() => {
    if (apiNoTerminadoRecords && apiNoTerminadoRecords.length > 0) {
      const mapped = apiNoTerminadoRecords.map(r => ({
        id: r.id_bitacora_envasado_no_terminado || r.id,
        id_bitacora_envasado_no_terminado: r.id_bitacora_envasado_no_terminado,
        fechaMovimiento: r.fecha_movimiento ? new Date(r.fecha_movimiento).toISOString().split('T')[0] : '2026-07-19',
        botCaja: r.bot_caja || '12 botellas',
        marca: r.marca || 'SIN MARCA',
        noLoteGranel: r.no_lote_granel || 'SIN-GRANEL',
        loteEnvasado: r.lote_envasado || 'L-ENV-NT',
        categoria: r.categoria || 'Mezcal Artesanal',
        clase: r.clase || 'Joven / Blanco',
        ingrediente: r.ingrediente || 'Maguey Espadín',
        edad: r.edad || 'Sin edad',
        tipoMaguey: r.tipo_maguey || 'Espadín',
        noAnalisis: r.no_analisis || 'N/A',
        capacidad: r.capacidad || '750 ml',
        pctAlc: r.pct_alc || '48.5',
        invInicialCajas: r.inv_inicial_cajas || 0,
        invInicialBotellas: r.inv_inicial_botellas || 0,
        entradaProcedencia: r.entrada_procedencia || 'Línea 1',
        entradaCajas: r.entrada_cajas || 0,
        entradaBotellas: r.entrada_botellas || 0,
        salidaCajas: r.salida_cajas || 0,
        salidaBotellas: r.salida_botellas || 0,
        salidaDestino: r.salida_destino || 'Etiquetado',
        invFinalCajas: r.inv_final_cajas || 0,
        invFinalBotellas: r.inv_final_botellas || 0,
        mermas: r.mermas || '0',
        observaciones: r.observaciones || '',
        inspector: r.vbo_inspector || 'Pendiente de V.Bo.',
        status: r.estatus || 'borrador',
        estadoProceso: r.estado_proceso || 'no_terminado'
      }));
      setNoTerminadoRecords(mapped);
    }
  }, [apiNoTerminadoRecords]);

  // ================= FORM STATES (SECCION II) =================
  const [fechaMovimiento, setFechaMovimiento] = useState("2026-07-19");
  const [idContenedor, setIdContenedor] = useState("C-10");
  const [noLote, setNoLote] = useState("PROD-LOTE-01");
  const [categoria, setCategoria] = useState("Mezcal Artesanal");
  const [clase, setClase] = useState("Joven / Blanco");
  const [ingrediente, setIngrediente] = useState("Maguey Espadín");
  const [edad, setEdad] = useState("Sin edad");
  const [tipoMaguey, setTipoMaguey] = useState("Espadín");
  const [noAnalisis, setNoAnalisis] = useState("ANA-2026-098");
  const [invInicialVol, setInvInicialVol] = useState("700");
  const [invInicialAlc, setInvInicialAlc] = useState("48.5");
  const [entradaProcedencia, setEntradaProcedencia] = useState("Destilación Lote 02");
  const [entradaVolumen, setEntradaVolumen] = useState("500");
  const [entradaAlc, setEntradaAlc] = useState("48.0");
  const [entradaVolAgua, setEntradaVolAgua] = useState("10");
  const [salidaVolumen, setSalidaVolumen] = useState("0");
  const [salidaAlc, setSalidaAlc] = useState("0.0");
  const [salidaDestino, setSalidaDestino] = useState("N/A");
  const [invFinalVol, setInvFinalVol] = useState("1210");
  const [invFinalAlc, setInvFinalAlc] = useState("47.8");
  const [observaciones, setObservaciones] = useState("");

  // ================= FORM STATES (SECCION III) =================
  const [ntFechaMovimiento, setNtFechaMovimiento] = useState("2026-07-19");
  const [ntBotCaja, setNtBotCaja] = useState("12 botellas");
  const [ntMarca, setNtMarca] = useState("Don Julio Mezcal");
  const [ntNoLoteGranel, setNtNoLoteGranel] = useState("PROD-LOTE-01");
  const [ntLoteEnvasado, setNtLoteEnvasado] = useState("L-01-ENV-NT");
  const [ntCategoria, setNtCategoria] = useState("Mezcal Artesanal");
  const [ntClase, setNtClase] = useState("Joven / Blanco");
  const [ntIngrediente, setNtIngrediente] = useState("Maguey Espadín");
  const [ntEdad, setNtEdad] = useState("Sin edad");
  const [ntTipoMaguey, setNtTipoMaguey] = useState("Espadín");
  const [ntNoAnalisis, setNtNoAnalisis] = useState("ANA-2026-098");
  const [ntCapacidad, setNtCapacidad] = useState("750 ml");
  const [ntPctAlc, setNtPctAlc] = useState("48.5");
  const [ntInvInicialCajas, setNtInvInicialCajas] = useState("40");
  const [ntInvInicialBotellas, setNtInvInicialBotellas] = useState("480");
  const [ntEntradaProcedencia, setNtEntradaProcedencia] = useState("Línea de Envasado 1");
  const [ntEntradaCajas, setNtEntradaCajas] = useState("20");
  const [ntEntradaBotellas, setNtEntradaBotellas] = useState("240");
  const [ntSalidaCajas, setNtSalidaCajas] = useState("15");
  const [ntSalidaBotellas, setNtSalidaBotellas] = useState("180");
  const [ntSalidaDestino, setNtSalidaDestino] = useState("Área de Etiquetado y Hologramas");
  const [ntInvFinalCajas, setNtInvFinalCajas] = useState("45");
  const [ntInvFinalBotellas, setNtInvFinalBotellas] = useState("540");
  const [ntMermas, setNtMermas] = useState("0");
  const [ntObservaciones, setNtObservaciones] = useState("");

  // ================= FORM STATES (SECCION IV) =================
  const [tFechaMovimiento, setTFechaMovimiento] = useState("2026-07-19");
  const [tBotCaja, setTBotCaja] = useState("12 botellas");
  const [tMarca, setTMarca] = useState("Don Julio Mezcal");
  const [tNoLoteGranel, setTNoLoteGranel] = useState("PROD-LOTE-01");
  const [tLoteEnvasado, setTLoteEnvasado] = useState("L-01-ENV-T");
  const [tCategoria, setTCategoria] = useState("Mezcal Artesanal");
  const [tClaseEtiqueta, setTClaseEtiqueta] = useState("Joven / Blanco");
  const [tIngredientesEtiqueta, setTIngredientesEtiqueta] = useState("Maguey Espadín");
  const [tEdad, setTEdad] = useState("Sin edad");
  const [tTipoMagueyEtiqueta, setTTipoMagueyEtiqueta] = useState("Espadín");
  const [tNoAnalisis, setTNoAnalisis] = useState("ANA-2026-098");
  const [tCapacidad, setTCapacidad] = useState("750 ml");
  const [tPctAlcEtiqueta, setTPctAlcEtiqueta] = useState("48.5");
  const [tNoInformeAprobacion, setTNoInformeAprobacion] = useState("INF-APR-ET-102");
  const [tFechaAprobacionEtiqueta, setTFechaAprobacionEtiqueta] = useState("2026-07-17");
  const [tInvInicialCajas, setTInvInicialCajas] = useState("5");
  const [tInvInicialBotellas, setTInvInicialBotellas] = useState("60");
  const [tEntradaProcedencia, setTEntradaProcedencia] = useState("Etiquetado Lote NT-01");
  const [tEntradaCajas, setTEntradaCajas] = useState("15");
  const [tEntradaBotellas, setTEntradaBotellas] = useState("180");
  const [tSalidaCajas, setTSalidaCajas] = useState("10");
  const [tSalidaBotellas, setTSalidaBotellas] = useState("120");
  const [tSalidaDestino, setTSalidaDestino] = useState("Almacén de Producto Terminado");
  const [tInvFinalCajas, setTInvFinalCajas] = useState("10");
  const [tInvFinalBotellas, setTInvFinalBotellas] = useState("120");
  const [tObservaciones, setTObservaciones] = useState("");

  // ================= FORM STATES (SECCION V) =================
  const [hIdEnvasadoTerminado, setHIdEnvasadoTerminado] = useState("T-ENV-01");
  const [hFechaMovimiento, setHFechaMovimiento] = useState("2026-07-19");
  const [hMarca, setHMarca] = useState("Don Julio Mezcal");
  const [hLoteEnvasado, setHLoteEnvasado] = useState("L-01-ENV-T");
  const [hCapacidad, setHCapacidad] = useState("750 ml");
  const [hInvInicialRango, setHInvInicialRango] = useState("A0123 - A0500");
  const [hInvInicialCant, setHInvInicialCant] = useState("378");
  const [hEntradaRango, setHEntradaRango] = useState("B0001 - B0500");
  const [hEntradaCant, setHEntradaCant] = useState("500");
  const [hSalidaRango, setHSalidaRango] = useState("A0123 - A0223");
  const [hSalidaCant, setHSalidaCant] = useState("101");
  const [hInvFinalRango, setHInvFinalRango] = useState("A0224 - A0500, B0001 - B0500");
  const [hInvFinalCant, setHInvFinalCant] = useState("777");
  const [hMermasRango, setHMermasRango] = useState("N/A");
  const [hMermasCant, setHMermasCant] = useState("0");
  const [hObservaciones, setHObservaciones] = useState("");

  // ================= FORM STATES (SECCION VI) =================
  const [elabFechaIngreso, setElabFechaIngreso] = useState("2026-07-19");
  const [elabLoteOrigen, setElabLoteOrigen] = useState("PROD-LOTE-01");
  const [elabVolumenOrigen, setElabVolumenOrigen] = useState("700");
  const [elabPctAlcOrigen, setElabPctAlcOrigen] = useState("48.5");
  const [elabCategoriaOrigen, setElabCategoriaOrigen] = useState("Mezcal Artesanal");
  const [elabClaseOrigen, setElabClaseOrigen] = useState("Joven / Blanco");
  const [elabIngredientesOrigen, setElabIngredientesOrigen] = useState("Maguey Espadín");
  const [elabEdadOrigen, setElabEdadOrigen] = useState("Sin edad");
  const [elabAnalisisOrigen, setElabAnalisisOrigen] = useState("ANA-2026-098");
  const [elabTipoMagueyOrigen, setElabTipoMagueyOrigen] = useState("Espadín");
  const [elabIngredientesAdicionados, setElabIngredientesAdicionados] = useState("Gusano de maguey");
  const [elabProcesoRealizado, setElabProcesoRealizado] = useState("ABOCADO CON");
  const [elabDescripcionProceso, setElabDescripcionProceso] = useState("Proceso de abocado con gusano.");
  const [elabFechaSalida, setElabFechaSalida] = useState("2026-07-19");
  const [elabLoteSalida, setElabLoteSalida] = useState("L-01-ENV-AB");
  const [elabVolumenSalida, setElabVolumenSalida] = useState("695");
  const [elabPctAlcSalida, setElabPctAlcSalida] = useState("48.2");
  const [elabClaseSalida, setElabClaseSalida] = useState("Abocado con Gusano");
  const [elabObservaciones, setElabObservaciones] = useState("");

  // ================= FORM STATES (SECCION VII) =================
  const [madFechaMovimiento, setMadFechaMovimiento] = useState("2026-07-19");
  const [madNoLote, setMadNoLote] = useState("PROD-LOTE-01");
  const [madCategoria, setMadCategoria] = useState("Mezcal Artesanal");
  const [madClase, setMadClase] = useState("Joven / Blanco");
  const [madIngredientes, setMadIngredientes] = useState("Maguey Espadín");
  const [madEdad, setMadEdad] = useState("Sin edad");
  const [madTipoMaguey, setMadTipoMaguey] = useState("Espadín");
  const [madNoAnalisis, setMadNoAnalisis] = useState("ANA-2026-098");
  const [madTipoRecipiente, setMadTipoRecipiente] = useState("BARRICAS DE MADERA DE");
  const [madDetalleRecipiente, setMadDetalleRecipiente] = useState("Roble Blanco Americano");
  const [madInvInicialFecha, setMadInvInicialFecha] = useState("2026-07-19");
  const [madInvInicialRecipientes, setMadInvInicialRecipientes] = useState("2");
  const [madInvInicialVolumen, setMadInvInicialVolumen] = useState("400");
  const [madInvInicialAlc, setMadInvInicialAlc] = useState("48.5");
  const [madEntradaFolio, setMadEntradaFolio] = useState("");
  const [madEntradaRecipientes, setMadEntradaRecipientes] = useState("0");
  const [madEntradaVolumen, setMadEntradaVolumen] = useState("0");
  const [madEntradaAlc, setMadEntradaAlc] = useState("0.0");
  const [madSalidaRecipientes, setMadSalidaRecipientes] = useState("1");
  const [madSalidaVolumen, setMadSalidaVolumen] = useState("200");
  const [madSalidaAlc, setMadSalidaAlc] = useState("48.0");
  const [madSalidaClaseObtenida, setMadSalidaClaseObtenida] = useState("Reposado");
  const [madSalidaEdadObtenida, setMadSalidaEdadObtenida] = useState("3 meses");
  const [madSalidaMerma, setMadSalidaMerma] = useState("5");
  const [madInvFinalRecipientes, setMadInvFinalRecipientes] = useState("1");
  const [madInvFinalVolumen, setMadInvFinalVolumen] = useState("195");
  const [madInvFinalAlc, setMadInvFinalAlc] = useState("48.0");
  const [madObservaciones, setMadObservaciones] = useState("");

  // ================= FORM STATES (SECCION VIII) =================
  const [condMesAnio, setCondMesAnio] = useState("Julio 2026");
  const [condNoLote, setCondNoLote] = useState("PROD-LOTE-01");
  const [condDailyData, setCondDailyData] = useState(generateDefaultDailyData());
  const [condObservaciones, setCondObservaciones] = useState("");

  // ================= FORM STATES (SECCION IX) =================
  const [fechaQueja, setFechaQueja] = useState("2026-07-19");
  const [noQueja, setNoQueja] = useState("");
  const [quejaNoLote, setQuejaNoLote] = useState("manual");
  const [descripcionProducto, setDescripcionProducto] = useState("");
  const [detalleQueja, setDetalleQueja] = useState("");
  const [fechaAtencion, setFechaAtencion] = useState("");
  const [medidasCorrectivas, setMedidasCorrectivas] = useState("");

  const handleSaveGranel = (status) => {
    const newRecord = {
      id: `GRA-ENV-0${granelRecords.length + 1}`,
      fechaMovimiento,
      idContenedor,
      noLote,
      categoria,
      clase,
      ingrediente,
      edad,
      tipoMaguey,
      noAnalisis,
      invInicialVol,
      invInicialAlc,
      entradaProcedencia,
      entradaVolumen,
      entradaAlc,
      entradaVolAgua,
      salidaVolumen,
      salidaAlc,
      salidaDestino,
      invFinalVol,
      invFinalAlc,
      observaciones: observaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setGranelRecords([...granelRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Granel registrado exitosamente en Bitácora de Envasado!" : "Borrador guardado.");
  };

  const handleEditGranelRecord = (rec) => {
    if (rec) {
      setFechaMovimiento(rec.fechaMovimiento || "");
      setIdContenedor(rec.idContenedor || "");
      setNoLote(rec.noLote || "");
      setCategoria(rec.categoria || "Mezcal Artesanal");
      setClase(rec.clase || "Joven / Blanco");
      setIngrediente(rec.ingrediente || rec.ingredientes || "");
      setEdad(rec.edad || "");
      setTipoMaguey(rec.tipoMaguey || "");
      setNoAnalisis(rec.noAnalisis || "");
      setInvInicialVol(rec.invInicialVol || "0");
      setInvInicialAlc(rec.invInicialAlc || "0");
      setEntradaProcedencia(rec.entradaProcedencia || "");
      setEntradaVolumen(rec.entradaVolumen || "0");
      setEntradaAlc(rec.entradaAlc || "0");
      setEntradaVolAgua(rec.entradaVolAgua || "0");
      setSalidaVolumen(rec.salidaVolumen || "0");
      setSalidaAlc(rec.salidaAlc || "0");
      setSalidaDestino(rec.salidaDestino || "");
      setInvFinalVol(rec.invFinalVol || "0");
      setInvFinalAlc(rec.invFinalAlc || "0");
      setObservaciones(rec.observaciones || "");
      setIsFormOpen(true);
    }
  };

  const handleSaveNoTerminado = (status) => {
    const recordPayload = {
      id_login: idLogin,
      fecha_movimiento: ntFechaMovimiento,
      bot_caja: ntBotCaja,
      marca: ntMarca,
      no_lote_granel: ntNoLoteGranel,
      lote_envasado: ntLoteEnvasado,
      categoria: ntCategoria,
      clase: ntClase,
      ingrediente: ntIngrediente,
      edad: ntEdad,
      tipo_maguey: ntTipoMaguey,
      no_analisis: ntNoAnalisis,
      capacidad: ntCapacidad,
      pct_alc: parseFloat(ntPctAlc) || 48.5,
      inv_inicial_cajas: parseInt(ntInvInicialCajas) || 0,
      inv_inicial_botellas: parseInt(ntInvInicialBotellas) || 0,
      entrada_procedencia: ntEntradaProcedencia,
      entrada_cajas: parseInt(ntEntradaCajas) || 0,
      entrada_botellas: parseInt(ntEntradaBotellas) || 0,
      salida_cajas: parseInt(ntSalidaCajas) || 0,
      salida_botellas: parseInt(ntSalidaBotellas) || 0,
      salida_destino: ntSalidaDestino,
      inv_final_cajas: parseInt(ntInvFinalCajas) || 0,
      inv_final_botellas: parseInt(ntInvFinalBotellas) || 0,
      mermas: ntMermas || "0",
      observaciones: ntObservaciones || "Sin observaciones.",
      estatus: status
    };

    if (idLogin) {
      dispatch(guardarNoTerminadoRecord(recordPayload));
    }

    const newRecord = {
      id: `NT-ENV-0${noTerminadoRecords.length + 1}`,
      fechaMovimiento: ntFechaMovimiento,
      botCaja: ntBotCaja,
      marca: ntMarca,
      noLoteGranel: ntNoLoteGranel,
      loteEnvasado: ntLoteEnvasado,
      categoria: ntCategoria,
      clase: ntClase,
      ingrediente: ntIngrediente,
      edad: ntEdad,
      tipoMaguey: ntTipoMaguey,
      noAnalisis: ntNoAnalisis,
      capacidad: ntCapacidad,
      pctAlc: ntPctAlc,
      invInicialCajas: ntInvInicialCajas,
      invInicialBotellas: ntInvInicialBotellas,
      entradaProcedencia: ntEntradaProcedencia,
      entradaCajas: ntEntradaCajas,
      entradaBotellas: ntEntradaBotellas,
      salidaCajas: ntSalidaCajas,
      salidaBotellas: ntSalidaBotellas,
      salidaDestino: ntSalidaDestino,
      invFinalCajas: ntInvFinalCajas,
      invFinalBotellas: ntInvFinalBotellas,
      mermas: ntMermas || "0",
      observaciones: ntObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setNoTerminadoRecords([...noTerminadoRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Envasado No Terminado registrado!" : "Borrador guardado.");
  };

  const handleSaveTerminado = (status) => {
    const newRecord = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      fechaMovimiento: tFechaMovimiento,
      botCaja: tBotCaja,
      marca: tMarca,
      noLoteGranel: tNoLoteGranel,
      loteEnvasado: tLoteEnvasado,
      categoria: tCategoria,
      claseEtiqueta: tClaseEtiqueta,
      ingredientesEtiqueta: tIngredientesEtiqueta,
      edad: tEdad,
      tipoMagueyEtiqueta: tTipoMagueyEtiqueta,
      noAnalisis: tNoAnalisis,
      capacidad: tCapacidad,
      pctAlcEtiqueta: tPctAlcEtiqueta,
      noInformeAprobacion: tNoInformeAprobacion,
      fechaAprobacionEtiqueta: tFechaAprobacionEtiqueta,
      invInicialCajas: tInvInicialCajas,
      invInicialBotellas: tInvInicialBotellas,
      entradaProcedencia: tEntradaProcedencia,
      entradaCajas: tEntradaCajas,
      entradaBotellas: tEntradaBotellas,
      salidaCajas: tSalidaCajas,
      salidaBotellas: tSalidaBotellas,
      salidaDestino: tSalidaDestino,
      invFinalCajas: tInvFinalCajas,
      invFinalBotellas: tInvFinalBotellas,
      observaciones: tObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setTerminadoRecords([...terminadoRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Movimiento de Envasado Terminado registrado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveHologramas = (status) => {
    const newRecord = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: hIdEnvasadoTerminado,
      fechaMovimiento: hFechaMovimiento,
      marca: hMarca,
      loteEnvasado: hLoteEnvasado,
      capacidad: hCapacidad,
      invInicialRango: hInvInicialRango,
      invInicialCant: hInvInicialCant,
      entradaRango: hEntradaRango,
      entradaCant: hEntradaCant,
      salidaRango: hSalidaRango,
      salidaCant: hSalidaCant,
      invFinalRango: hInvFinalRango,
      invFinalCant: hInvFinalCant,
      mermasRango: hMermasRango,
      mermasCant: hMermasCant,
      observaciones: hObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setHologramaRecords([...hologramaRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Inventario de Hologramas registrado exitosamente!" : "Borrador guardado.");
  };

  const handleCompleteEnvasadoFromNoTerminado = (sourceRec, finishedData) => {
    const origId = sourceRec.id_bitacora_envasado_no_terminado || sourceRec.id;

    if (idLogin) {
      dispatch(guardarTerminadoRecord({
        id_login: idLogin,
        id_bitacora_envasado_no_terminado: typeof origId === 'number' ? origId : parseInt(origId) || null,
        fecha_movimiento: sourceRec.fechaMovimiento || finishedData.fechaAprobacionEtiqueta || new Date().toISOString().split("T")[0],
        bot_caja: sourceRec.botCaja || "12 botellas",
        marca: sourceRec.marca,
        no_lote_granel: sourceRec.noLoteGranel,
        lote_envasado: sourceRec.loteEnvasado,
        categoria: sourceRec.categoria,
        clase_etiqueta: finishedData.claseEtiqueta || sourceRec.clase || "Joven / Blanco",
        ingredientes_etiqueta: finishedData.ingredientesEtiqueta || sourceRec.ingrediente || "",
        edad: sourceRec.edad || "Sin edad",
        tipo_maguey_etiqueta: finishedData.tipoMagueyEtiqueta || sourceRec.tipoMaguey || "Espadín",
        no_analisis: sourceRec.noAnalisis,
        capacidad: sourceRec.capacidad || "750 ml",
        pct_alc_etiqueta: parseFloat(finishedData.pctAlcEtiqueta || sourceRec.pctAlc) || 48.5,
        no_informe_aprobacion: finishedData.noInformeAprobacion,
        fecha_aprobacion_etiqueta: finishedData.fechaAprobacionEtiqueta,
        inv_inicial_cajas: parseInt(finishedData.invInicialCajas) || 0,
        inv_inicial_botellas: parseInt(finishedData.invInicialBotellas) || 0,
        entrada_procedencia: finishedData.entradaProcedencia || `Etiquetado de lote ${sourceRec.loteEnvasado}`,
        entrada_cajas: parseInt(finishedData.entradaCajas) || 0,
        entrada_botellas: parseInt(finishedData.entradaBotellas) || 0,
        salida_cajas: parseInt(finishedData.salidaCajas) || 0,
        salida_botellas: parseInt(finishedData.salidaBotellas) || 0,
        salida_destino: finishedData.salidaDestino || "Almacén de Producto Terminado",
        inv_final_cajas: parseInt(finishedData.invFinalCajas) || 0,
        inv_final_botellas: parseInt(finishedData.invFinalBotellas) || 0,
        observaciones: finishedData.observaciones || "Envasado Terminado (Sección IV)",
        estatus: "revision"
      }));
    }

    const newTerminado = {
      id: `T-ENV-0${terminadoRecords.length + 1}`,
      idNoTerminadoOrigen: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || finishedData.fechaAprobacionEtiqueta || new Date().toISOString().split("T")[0],
      botCaja: sourceRec.botCaja || "12 botellas",
      marca: sourceRec.marca,
      noLoteGranel: sourceRec.noLoteGranel,
      loteEnvasado: sourceRec.loteEnvasado,
      categoria: sourceRec.categoria,
      claseEtiqueta: finishedData.claseEtiqueta || sourceRec.clase || "Joven / Blanco",
      ingredientesEtiqueta: finishedData.ingredientesEtiqueta || sourceRec.ingrediente || "",
      edad: sourceRec.edad || "Sin edad",
      tipoMagueyEtiqueta: finishedData.tipoMagueyEtiqueta || sourceRec.tipoMaguey || "Espadín",
      noAnalisis: sourceRec.noAnalisis,
      capacidad: sourceRec.capacidad || "750 ml",
      pctAlcEtiqueta: finishedData.pctAlcEtiqueta || sourceRec.pctAlc || "48.5",
      noInformeAprobacion: finishedData.noInformeAprobacion,
      fechaAprobacionEtiqueta: finishedData.fechaAprobacionEtiqueta,
      invInicialCajas: finishedData.invInicialCajas || "0",
      invInicialBotellas: finishedData.invInicialBotellas || "0",
      entradaProcedencia: finishedData.entradaProcedencia || `Etiquetado de lote ${sourceRec.loteEnvasado}`,
      entradaCajas: finishedData.entradaCajas || "0",
      entradaBotellas: finishedData.entradaBotellas || "0",
      salidaCajas: finishedData.salidaCajas || "0",
      salidaBotellas: finishedData.salidaBotellas || "0",
      salidaDestino: finishedData.salidaDestino || "Almacén de Producto Terminado",
      invFinalCajas: finishedData.invFinalCajas || "0",
      invFinalBotellas: finishedData.invFinalBotellas || "0",
      observaciones: finishedData.observaciones || "Envasado Terminado (Sección IV)",
      inspector: "Pendiente de V.Bo.",
      status: "revision",
      estadoProceso: "terminado"
    };

    setTerminadoRecords(prev => [...prev, newTerminado]);

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "terminado" } : item
      )
    );
  };

  const handleSaveHologramasFromNoTerminado = (sourceRec, hologramData) => {
    const origId = sourceRec.id_bitacora_envasado_terminado || sourceRec.id;

    if (idLogin) {
      dispatch(guardarHologramasRecord({
        id_login: idLogin,
        id_bitacora_envasado_terminado: typeof origId === 'number' ? origId : parseInt(origId) || null,
        fecha_movimiento: sourceRec.fechaMovimiento || new Date().toISOString().split("T")[0],
        marca: sourceRec.marca,
        lote_envasado: sourceRec.loteEnvasado,
        capacidad: sourceRec.capacidad || "750 ml",
        inv_inicial_rango: hologramData.invInicialRango,
        inv_inicial_cant: parseInt(hologramData.invInicialCant) || 0,
        entrada_rango: hologramData.entradaRango,
        entrada_cant: parseInt(hologramData.entradaCant) || 0,
        salida_rango: hologramData.salidaRango,
        salida_cant: parseInt(hologramData.salidaCant) || 0,
        inv_final_rango: hologramData.invFinalRango,
        inv_final_cant: parseInt(hologramData.invFinalCant) || 0,
        mermas_rango: hologramData.mermasRango,
        mermas_cant: parseInt(hologramData.mermasCant) || 0,
        observaciones: hologramData.observaciones || "Control de Hologramas (Sección V)",
        estatus: "revision"
      }));
    }

    const newHologramas = {
      id: `HOL-0${hologramaRecords.length + 1}`,
      idEnvasadoTerminado: sourceRec.id,
      fechaMovimiento: sourceRec.fechaMovimiento || new Date().toISOString().split("T")[0],
      marca: sourceRec.marca,
      loteEnvasado: sourceRec.loteEnvasado,
      capacidad: sourceRec.capacidad || "750 ml",
      invInicialRango: hologramData.invInicialRango,
      invInicialCant: hologramData.invInicialCant,
      entradaRango: hologramData.entradaRango,
      entradaCant: hologramData.entradaCant,
      salidaRango: hologramData.salidaRango,
      salidaCant: hologramData.salidaCant,
      invFinalRango: hologramData.invFinalRango,
      invFinalCant: hologramData.invFinalCant,
      mermasRango: hologramData.mermasRango,
      mermasCant: hologramData.mermasCant,
      observaciones: hologramData.observaciones || "Control de Hologramas (Sección V)",
      inspector: "Pendiente de V.Bo.",
      status: "revision"
    };

    setHologramaRecords(prev => [...prev, newHologramas]);

    setNoTerminadoRecords(prev =>
      prev.map(item =>
        item.id === sourceRec.id ? { ...item, estadoProceso: "hologramado" } : item
      )
    );

    setTerminadoRecords(prev =>
      prev.map(item =>
        item.loteEnvasado === sourceRec.loteEnvasado ? { ...item, estadoProceso: "hologramado" } : item
      )
    );
  };


  const handleSaveElaboracion = (status) => {
    const newRecord = {
      id: `ELAB-0${elaboracionRecords.length + 1}`,
      fechaIngreso: elabFechaIngreso,
      loteOrigen: elabLoteOrigen,
      volumenOrigen: elabVolumenOrigen,
      pctAlcOrigen: elabPctAlcOrigen,
      categoriaOrigen: elabCategoriaOrigen,
      claseOrigen: elabClaseOrigen,
      ingredientesOrigen: elabIngredientesOrigen,
      edadOrigen: elabEdadOrigen,
      analisisOrigen: elabAnalisisOrigen,
      tipoMagueyOrigen: elabTipoMagueyOrigen,
      ingredientesAdicionados: elabIngredientesAdicionados,
      procesoRealizado: elabProcesoRealizado,
      descripcionProceso: elabDescripcionProceso,
      fechaSalida: elabFechaSalida,
      loteSalida: elabLoteSalida,
      volumenSalida: elabVolumenSalida,
      pctAlcSalida: elabPctAlcSalida,
      claseSalida: elabClaseSalida,
      observaciones: elabObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setElaboracionRecords([...elaboracionRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Elaboración de Clase registrada exitosamente!" : "Borrador guardado.");
  };

  const handleSaveMaduracion = (status) => {
    const newRecord = {
      id: `MAD-0${maduracionRecords.length + 1}`,
      fechaMovimiento: madFechaMovimiento,
      noLote: madNoLote,
      categoria: madCategoria,
      clase: madClase,
      ingredientes: madIngredientes,
      edad: madEdad,
      tipoMaguey: madTipoMaguey,
      noAnalisis: madNoAnalisis,
      tipoRecipiente: madTipoRecipiente,
      detalleRecipiente: madDetalleRecipiente,
      invInicialFecha: madInvInicialFecha,
      invInicialRecipientes: madInvInicialRecipientes,
      invInicialVolumen: madInvInicialVolumen,
      invInicialAlc: madInvInicialAlc,
      entradaFolio: madEntradaFolio || "N/A",
      entradaRecipientes: madEntradaRecipientes,
      entradaVolumen: madEntradaVolumen,
      entradaAlc: madEntradaAlc,
      salidaRecipientes: madSalidaRecipientes,
      salidaVolumen: madSalidaVolumen,
      salidaAlc: madSalidaAlc,
      salidaClaseObtenida: madSalidaClaseObtenida,
      salidaEdadObtenida: madSalidaEdadObtenida,
      salidaMerma: madSalidaMerma,
      invFinalRecipientes: madInvFinalRecipientes,
      invFinalVolumen: madInvFinalVolumen,
      invFinalAlc: madInvFinalAlc,
      observaciones: madObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setMaduracionRecords([...maduracionRecords, newRecord]);
    setIsFormOpen(false);
    alert(status === "revision" ? "¡Registro de Maduración guardado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveCondiciones = (status) => {
    const newRecord = {
      mesAnio: condMesAnio,
      noLote: condNoLote,
      registros: [...condDailyData],
      observaciones: condObservaciones || "Sin observaciones.",
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setCondicionesRecords([...condionesRecords, newRecord]);
    setIsFormOpen(false);
    setCondDailyData(generateDefaultDailyData());
    alert(status === "revision" ? "¡Registro mensual de condiciones guardado exitosamente!" : "Borrador guardado.");
  };

  const handleSaveQueja = (status) => {
    const newRecord = {
      id: quejasRecords.length + 1,
      fechaQueja,
      noQueja,
      noLote: quejaNoLote,
      descripcionProducto,
      detalleQueja,
      fechaAtencion,
      medidasCorrectivas,
      inspector: "Pendiente de V.Bo.",
      status: status
    };
    setQuejasRecords([...quejasRecords, newRecord]);
    setIsFormOpen(false);
    setNoQueja("");
    setDetalleQueja("");
    setMedidasCorrectivas("");
    alert(status === "revision" ? "¡Queja registrada exitosamente!" : "Borrador guardado.");
  };

  return (
    <div className="bg-glow-container min-h-screen p-4 md:p-8">
      {/* Decorative Blurs */}
      <div className="glow-blob-1"></div>
      <div className="glow-blob-2"></div>

      {/* Main SaaS Card */}
      <div className="bitacora-wrapper">
        
        {/* HEADER */}
        <header className="bitacora-header">
          <div className="header-logo-container">
            <div className="header-icon">
              <LocalBarIcon />
            </div>
            <div className="header-title-text">
              <span>Módulo de Trazabilidad Comercial</span>
              <h1>Bitácora de Envasado de Mezcal</h1>
            </div>
          </div>

          <div className="header-controls">
            <span className={`status-badge ${tabsInfo[activeTab].theme}`}>
              {tabsInfo[activeTab].name}
            </span>

            <div style={{ position: "relative" }}>
              <button 
                onClick={() => setShowBatchDropdown(!showBatchDropdown)}
                className="batch-select-btn"
              >
                <span>{activeBatch}</span>
                <KeyboardArrowDownIcon style={{ fontSize: 18 }} />
              </button>

              {showBatchDropdown && (
                <div className="dropdown-menu-custom">
                  {batches.map((batch, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        setActiveBatch(batch);
                        setShowBatchDropdown(false);
                      }}
                      className={`dropdown-item-custom ${activeBatch === batch ? 'active' : ''}`}
                    >
                      {batch}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </header>

        {/* SECTIONS TABS AS CARDS */}
        <nav className="sections-grid">
          {tabsInfo.map((tab, index) => {
            const IconComponent = tab.icon;
            return (
              <button
                key={index}
                onClick={() => {
                  setActiveTab(index);
                  setIsFormOpen(false); // Reset to list view when tab changes
                }}
                className={`section-nav-card ${activeTab === index ? 'active' : ''}`}
              >
                <div className="card-icon-container">
                  <IconComponent style={{ fontSize: 22 }} />
                </div>
                <div>
                  <span className="card-title-span">{tab.title}</span>
                  <span className="card-name-span">{tab.name}</span>
                  <span className="card-desc-span">{tab.desc}</span>
                </div>
              </button>
            );
          })}
        </nav>

        {/* ACTIVE SECTION CONTENT */}
        <main className="content-section-panel">
          
          {/* SECCIÓN II: GRANEL */}
          {activeTab === 0 && (
            <InventarioGranelSection
              granelRecords={granelRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaMovimiento={fechaMovimiento}
              setFechaMovimiento={setFechaMovimiento}
              idContenedor={idContenedor}
              setIdContenedor={setIdContenedor}
              noLote={noLote}
              setNoLote={setNoLote}
              categoria={categoria}
              setCategoria={setCategoria}
              clase={clase}
              setClase={setClase}
              ingrediente={ingrediente}
              setIngrediente={setIngrediente}
              edad={edad}
              setEdad={setEdad}
              tipoMaguey={tipoMaguey}
              setTipoMaguey={setTipoMaguey}
              noAnalisis={noAnalisis}
              setNoAnalisis={setNoAnalisis}
              invInicialVol={invInicialVol}
              setInvInicialVol={setInvInicialVol}
              invInicialAlc={invInicialAlc}
              setInvInicialAlc={setInvInicialAlc}
              entradaProcedencia={entradaProcedencia}
              setEntradaProcedencia={setEntradaProcedencia}
              entradaVolumen={entradaVolumen}
              setEntradaVolumen={setEntradaVolumen}
              entradaAlc={entradaAlc}
              setEntradaAlc={setEntradaAlc}
              entradaVolAgua={entradaVolAgua}
              setEntradaVolAgua={setEntradaVolAgua}
              salidaVolumen={salidaVolumen}
              setSalidaVolumen={setSalidaVolumen}
              salidaAlc={salidaAlc}
              setSalidaAlc={setSalidaAlc}
              salidaDestino={salidaDestino}
              setSalidaDestino={setSalidaDestino}
              invFinalVol={invFinalVol}
              setInvFinalVol={setInvFinalVol}
              invFinalAlc={invFinalAlc}
              setInvFinalAlc={setInvFinalAlc}
              observaciones={observaciones}
              setObservaciones={setObservaciones}
              handleSaveGranel={handleSaveGranel}
              handleEditRecord={handleEditGranelRecord}
            />
          )}

          {/* SECCIÓN III: ENVASADO NO TERMINADO */}
          {activeTab === 1 && (
            <EnvasadoNoTerminadoSection
              noTerminadoRecords={noTerminadoRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaMovimiento={ntFechaMovimiento}
              setFechaMovimiento={setNtFechaMovimiento}
              botCaja={ntBotCaja}
              setBotCaja={setNtBotCaja}
              marca={ntMarca}
              setMarca={setNtMarca}
              noLoteGranel={ntNoLoteGranel}
              setNoLoteGranel={setNtNoLoteGranel}
              loteEnvasado={ntLoteEnvasado}
              setLoteEnvasado={setNtLoteEnvasado}
              categoria={ntCategoria}
              setCategoria={setNtCategoria}
              clase={ntClase}
              setClase={setNtClase}
              ingrediente={ntIngrediente}
              setIngrediente={setNtIngrediente}
              edad={ntEdad}
              setEdad={setNtEdad}
              tipoMaguey={ntTipoMaguey}
              setTipoMaguey={setNtTipoMaguey}
              noAnalisis={ntNoAnalisis}
              setNoAnalisis={setNtNoAnalisis}
              capacidad={ntCapacidad}
              setCapacidad={setNtCapacidad}
              pctAlc={ntPctAlc}
              setPctAlc={setNtPctAlc}
              invInicialCajas={ntInvInicialCajas}
              setInvInicialCajas={setNtInvInicialCajas}
              invInicialBotellas={ntInvInicialBotellas}
              setInvInicialBotellas={setNtInvInicialBotellas}
              entradaProcedencia={ntEntradaProcedencia}
              setEntradaProcedencia={setNtEntradaProcedencia}
              entradaCajas={ntEntradaCajas}
              setEntradaCajas={setNtEntradaCajas}
              entradaBotellas={ntEntradaBotellas}
              setEntradaBotellas={setNtEntradaBotellas}
              salidaCajas={ntSalidaCajas}
              setSalidaCajas={setNtSalidaCajas}
              salidaBotellas={ntSalidaBotellas}
              setSalidaBotellas={setNtSalidaBotellas}
              salidaDestino={ntSalidaDestino}
              setSalidaDestino={setNtSalidaDestino}
              invFinalCajas={ntInvFinalCajas}
              setInvFinalCajas={setNtInvFinalCajas}
              invFinalBotellas={ntInvFinalBotellas}
              setInvFinalBotellas={setNtInvFinalBotellas}
              mermas={ntMermas}
              setMermas={setNtMermas}
              observaciones={ntObservaciones}
              setObservaciones={setNtObservaciones}
              handleSaveNoTerminado={handleSaveNoTerminado}
              onCompleteEnvasado={handleCompleteEnvasadoFromNoTerminado}
              onSaveHologramas={handleSaveHologramasFromNoTerminado}
            />
          )}

          {/* SECCIÓN IV: ENVASADO TERMINADO */}
          {activeTab === 2 && (
            <EnvasadoTerminadoSection
              terminadoRecords={terminadoRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaMovimiento={tFechaMovimiento}
              setFechaMovimiento={setTFechaMovimiento}
              botCaja={tBotCaja}
              setBotCaja={setTBotCaja}
              marca={tMarca}
              setMarca={setTMarca}
              noLoteGranel={tNoLoteGranel}
              setNoLoteGranel={setTNoLoteGranel}
              loteEnvasado={tLoteEnvasado}
              setLoteEnvasado={setTLoteEnvasado}
              categoria={tCategoria}
              setCategoria={setTCategoria}
              claseEtiqueta={tClaseEtiqueta}
              setClaseEtiqueta={setTClaseEtiqueta}
              ingredientesEtiqueta={tIngredientesEtiqueta}
              setIngredientesEtiqueta={setTIngredientesEtiqueta}
              edad={tEdad}
              setEdad={setTEdad}
              tipoMagueyEtiqueta={tTipoMagueyEtiqueta}
              setTipoMagueyEtiqueta={setTTipoMagueyEtiqueta}
              noAnalisis={tNoAnalisis}
              setNoAnalisis={setTNoAnalisis}
              capacidad={tCapacidad}
              setCapacidad={setTCapacidad}
              pctAlcEtiqueta={tPctAlcEtiqueta}
              setPctAlcEtiqueta={setTPctAlcEtiqueta}
              noInformeAprobacion={tNoInformeAprobacion}
              setNoInformeAprobacion={setTNoInformeAprobacion}
              fechaAprobacionEtiqueta={tFechaAprobacionEtiqueta}
              setFechaAprobacionEtiqueta={setTFechaAprobacionEtiqueta}
              invInicialCajas={tInvInicialCajas}
              setInvInicialCajas={setTInvInicialCajas}
              invInicialBotellas={tInvInicialBotellas}
              setInvInicialBotellas={setTInvInicialBotellas}
              entradaProcedencia={tEntradaProcedencia}
              setEntradaProcedencia={setTEntradaProcedencia}
              entradaCajas={tEntradaCajas}
              setEntradaCajas={setTEntradaCajas}
              entradaBotellas={tEntradaBotellas}
              setEntradaBotellas={setTEntradaBotellas}
              salidaCajas={tSalidaCajas}
              setSalidaCajas={setTSalidaCajas}
              salidaBotellas={tSalidaBotellas}
              setSalidaBotellas={setTSalidaBotellas}
              salidaDestino={tSalidaDestino}
              setSalidaDestino={setTSalidaDestino}
              invFinalCajas={tInvFinalCajas}
              setInvFinalCajas={setTInvFinalCajas}
              invFinalBotellas={tInvFinalBotellas}
              setInvFinalBotellas={setTInvFinalBotellas}
              observaciones={tObservaciones}
              setObservaciones={setTObservaciones}
              handleSaveTerminado={handleSaveTerminado}
            />
          )}

          {/* SECCIÓN V: CONTROL DE HOLOGRAMAS */}
          {activeTab === 3 && (
            <ControlHologramasSection
              hologramaRecords={hologramaRecords}
              terminadoRecords={terminadoRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              idEnvasadoTerminado={hIdEnvasadoTerminado}
              setIdEnvasadoTerminado={setHIdEnvasadoTerminado}
              fechaMovimiento={hFechaMovimiento}
              setFechaMovimiento={setHFechaMovimiento}
              marca={hMarca}
              setMarca={setHMarca}
              loteEnvasado={hLoteEnvasado}
              setLoteEnvasado={setHLoteEnvasado}
              capacidad={hCapacidad}
              setCapacidad={setHCapacidad}
              invInicialRango={hInvInicialRango}
              setInvInicialRango={setHInvInicialRango}
              invInicialCant={hInvInicialCant}
              setInvInicialCant={setHInvInicialCant}
              entradaRango={hEntradaRango}
              setEntradaRango={setHEntradaRango}
              entradaCant={hEntradaCant}
              setEntradaCant={setHEntradaCant}
              salidaRango={hSalidaRango}
              setSalidaRango={setHSalidaRango}
              salidaCant={hSalidaCant}
              setSalidaCant={setHSalidaCant}
              invFinalRango={hInvFinalRango}
              setInvFinalRango={setHInvFinalRango}
              invFinalCant={hInvFinalCant}
              setInvFinalCant={setHInvFinalCant}
              mermasRango={hMermasRango}
              setMermasRango={setHMermasRango}
              mermasCant={hMermasCant}
              setMermasCant={setHMermasCant}
              observaciones={hObservaciones}
              setObservaciones={setHObservaciones}
              handleSaveHologramas={handleSaveHologramas}
            />
          )}

          {/* SECCIÓN VI: ELABORACIÓN DE CLASES */}
          {activeTab === 4 && (
            <ElaboracionClasesSection
              elaboracionRecords={elaboracionRecords}
              granelRecords={granelRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaIngreso={elabFechaIngreso}
              setFechaIngreso={setElabFechaIngreso}
              loteOrigen={elabLoteOrigen}
              setLoteOrigen={setElabLoteOrigen}
              volumenOrigen={elabVolumenOrigen}
              setVolumenOrigen={setElabVolumenOrigen}
              pctAlcOrigen={elabPctAlcOrigen}
              setPctAlcOrigen={setElabPctAlcOrigen}
              categoriaOrigen={elabCategoriaOrigen}
              setCategoriaOrigen={setElabCategoriaOrigen}
              claseOrigen={elabClaseOrigen}
              setClaseOrigen={setElabClaseOrigen}
              ingredientesOrigen={elabIngredientesOrigen}
              setIngredientesOrigen={setElabIngredientesOrigen}
              edadOrigen={elabEdadOrigen}
              setEdadOrigen={setElabEdadOrigen}
              analisisOrigen={elabAnalisisOrigen}
              setAnalisisOrigen={setElabAnalisisOrigen}
              tipoMagueyOrigen={elabTipoMagueyOrigen}
              setTipoMagueyOrigen={setElabTipoMagueyOrigen}
              ingredientesAdicionados={elabIngredientesAdicionados}
              setIngredientesAdicionados={setElabIngredientesAdicionados}
              procesoRealizado={elabProcesoRealizado}
              setProcesoRealizado={setElabProcesoRealizado}
              descripcionProceso={elabDescripcionProceso}
              setDescripcionProceso={setElabDescripcionProceso}
              fechaSalida={elabFechaSalida}
              setFechaSalida={setElabFechaSalida}
              loteSalida={elabLoteSalida}
              setLoteSalida={setElabLoteSalida}
              volumenSalida={elabVolumenSalida}
              setVolumenSalida={setElabVolumenSalida}
              pctAlcSalida={elabPctAlcSalida}
              setPctAlcSalida={setElabPctAlcSalida}
              claseSalida={elabClaseSalida}
              setClaseSalida={setElabClaseSalida}
              observaciones={elabObservaciones}
              setObservaciones={setElabObservaciones}
              handleSaveElaboracion={handleSaveElaboracion}
            />
          )}

          {/* SECCIÓN VII: MADURACIÓN */}
          {activeTab === 5 && (
            <InventarioMaduracionSection
              maduracionRecords={maduracionRecords}
              granelRecords={granelRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaMovimiento={madFechaMovimiento}
              setFechaMovimiento={setMadFechaMovimiento}
              noLote={madNoLote}
              setMadNoLote={setMadNoLote}
              categoria={madCategoria}
              setMadCategoria={setMadCategoria}
              clase={madClase}
              setMadClase={setMadClase}
              ingredientes={madIngredientes}
              setMadIngredientes={setMadIngredientes}
              edad={madEdad}
              setMadEdad={setMadEdad}
              tipoMaguey={madTipoMaguey}
              setMadTipoMaguey={setMadTipoMaguey}
              noAnalisis={madNoAnalisis}
              setMadNoAnalisis={setMadNoAnalisis}
              tipoRecipiente={madTipoRecipiente}
              setMadTipoRecipiente={setMadTipoRecipiente}
              detalleRecipiente={madDetalleRecipiente}
              setMadDetalleRecipiente={setMadDetalleRecipiente}
              invInicialFecha={madInvInicialFecha}
              setMadInvInicialFecha={setMadInvInicialFecha}
              invInicialRecipientes={madInvInicialRecipientes}
              setMadInvInicialRecipientes={setMadInvInicialRecipientes}
              invInicialVolumen={madInvInicialVolumen}
              setMadInvInicialVolumen={setMadInvInicialVolumen}
              invInicialAlc={madInvInicialAlc}
              setMadInvInicialAlc={setMadInvInicialAlc}
              entradaFolio={madEntradaFolio}
              setMadEntradaFolio={setMadEntradaFolio}
              entradaRecipientes={madEntradaRecipientes}
              setMadEntradaRecipientes={setMadEntradaRecipientes}
              entradaVolumen={madEntradaVolumen}
              setMadEntradaVolumen={setMadEntradaVolumen}
              entradaAlc={entradaAlc}
              setMadEntradaAlc={setMadEntradaAlc}
              salidaRecipientes={madSalidaRecipientes}
              setMadSalidaRecipientes={setMadSalidaRecipientes}
              salidaVolumen={madSalidaVolumen}
              setMadSalidaVolumen={setMadSalidaVolumen}
              salidaAlc={madSalidaAlc}
              setMadSalidaAlc={setMadSalidaAlc}
              salidaClaseObtenida={madSalidaClaseObtenida}
              setMadSalidaClaseObtenida={setMadSalidaClaseObtenida}
              salidaEdadObtenida={madSalidaEdadObtenida}
              setMadSalidaEdadObtenida={setMadSalidaEdadObtenida}
              salidaMerma={madSalidaMerma}
              setMadSalidaMerma={setMadSalidaMerma}
              invFinalRecipientes={invFinalRecipientes}
              setMadInvFinalRecipientes={setMadInvFinalRecipientes}
              invFinalVolumen={invFinalVolumen}
              setMadInvFinalVolumen={setMadInvFinalVolumen}
              invFinalAlc={invFinalAlc}
              setMadInvFinalAlc={setMadInvFinalAlc}
              observaciones={madObservaciones}
              setObservaciones={setMadObservaciones}
              handleSaveMaduracion={handleSaveMaduracion}
            />
          )}

          {/* SECCIÓN VIII: CONDICIONES */}
          {activeTab === 6 && (
            <CondicionesMaduracionSection
              condicionesRecords={condionesRecords}
              maduracionRecords={maduracionRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              condMesAnio={condMesAnio}
              setCondMesAnio={setCondMesAnio}
              condNoLote={condNoLote}
              setCondNoLote={setCondNoLote}
              condDailyData={condDailyData}
              setCondDailyData={setCondDailyData}
              condObservaciones={condObservaciones}
              setCondObservaciones={setCondObservaciones}
              handleSaveCondiciones={handleSaveCondiciones}
            />
          )}

          {/* SECCIÓN IX: QUEJAS */}
          {activeTab === 7 && (
            <QuejasSection
              quejasRecords={quejasRecords}
              terminadoRecords={terminadoRecords}
              isFormOpen={isFormOpen}
              setIsFormOpen={setIsFormOpen}
              fechaQueja={fechaQueja}
              setFechaQueja={setFechaQueja}
              noQueja={noQueja}
              setNoQueja={setNoQueja}
              noLote={quejaNoLote}
              setNoLote={setQuejaNoLote}
              descripcionProducto={descripcionProducto}
              setDescripcionProducto={setDescripcionProducto}
              detalleQueja={detalleQueja}
              setDetalleQueja={setDetalleQueja}
              fechaAtencion={fechaAtencion}
              setFechaAtencion={setFechaAtencion}
              medidasCorrectivas={medidasCorrectivas}
              setMedidasCorrectivas={setMedidasCorrectivas}
              handleSaveQueja={handleSaveQueja}
            />
          )}

        </main>
      </div>
    </div>
  );
};

export default BitacoraEnvasado;